import { Component } from '@angular/core';

@Component({
  selector: 'uni-tiles',
  templateUrl: './uni-tiles.component.html',
  styleUrls: ['./uni-tiles.component.scss'],
})
export class UniTilesComponent {}
